import { useEditChargerFlowErrors } from '@features/chargerFlows/store';

export function useNodeError(nodeId: string) {
  const flowErrors = useEditChargerFlowErrors();

  if (!flowErrors) {
    return null;
  }

  const errors = flowErrors[nodeId];
  if (!errors) {
    return null;
  }

  return errors;
}
